module.exports = __webpack_public_path__ + "static/36-12n-379o-04-364d3dffa83e23ccfe9a5bd8d4e32754.jpg";